/* ==========================================================================
   Tiaroo 加载页 —— 只做收尾，不负责显示。
   --------------------------------------------------------------------------
   设计原则和 tiaro-motion.js 一致：这个脚本挂了、甚至整个 JS 被禁用，
   页面都必须照常可用。

   所以「遮罩消失」这件事完全不在这里 —— 它由 theme.liquid <head> 里那段
   内联 CSS 的动画负责（终态 opacity:0 + visibility:hidden，forwards 保持住）。
   本脚本只做两件锦上添花的事：
     1. 动画跑完后把节点从 DOM 摘掉，少一层 position:fixed 覆盖；
     2. 主题编辑器里（designMode）直接摘掉，免得改一次设置就糊一屏。
   ========================================================================== */
(function () {
  'use strict';

  function remove(el) {
    try {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    } catch (e) {}
  }

  function init() {
    var el = document.getElementById('tiaroo-intro');
    if (!el) return;

    // 主题编辑器里不重播（theme.liquid 里其实已经不渲染了，这里是第二道保险）
    try {
      if (window.Shopify && window.Shopify.designMode) {
        remove(el);
        return;
      }
    } catch (e) {}

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      remove(el);
    }

    // 淡出动画跑完 -> 摘掉。顺便把 animate-- 那个 logo 动画的事件过滤掉。
    try {
      el.addEventListener('animationend', function (ev) {
        if (ev.animationName === 'tiaroo-intro-out') finish();
      });
    } catch (e) {}

    // 兜底：动画因为任何原因没触发（系统设置、浏览器差异），也一定摘掉。
    // 后台最长可设 2500ms + 450ms 淡出，6s 足够宽裕。
    setTimeout(finish, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
